import { POST, GET } from '@/utils/request'
import Api from './url'

export const getRuleInfo = async (params: object) => {
  return await GET({
    url: Api.ruleInfo,
    params,
    showError: false
  })
}
